import PuffLoader from 'react-spinners/PuffLoader';
import { useSelector } from 'react-redux';

export const MainLoader = () => {
    const isLoading = useSelector((state) => state.mainLoader.isLoading);
    return (
        <>
            {isLoading ? (
                <div className="loader-spinner-bx">
                    <PuffLoader
                        color="#DB5F19"
                        loading={isLoading}
                        size={70}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            ) : (
                <div></div>
            )}
        </>
    );
};

export default MainLoader;
